/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Screen_config$ref: FragmentReference;
export type Screen_config = {|
  +id: string,
  +screenConfigs: ?$ReadOnlyArray<?{|
    +index: ?number,
    +name: ?string,
  |}>,
  +screenSequence: ?$ReadOnlyArray<?number>,
  +$refType: Screen_config$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Screen_config",
  "type": "InfoMonitorConfig",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "screenConfigs",
      "storageKey": null,
      "args": null,
      "concreteType": "ScreenConfig",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "index",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "screenSequence",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e5a0201649a3d61888da539a7e28407e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/scenes/Screen/__generated__/Screen_config.graphql.js